import Vue from 'vue'
import Router from 'vue-router'
import top from '@/view/top.vue'
import yeMast from '@/view/yeMast/yeMast.vue'
import product from '@/view/product.vue'
import security from '@/view/security.vue'
import solution from '@/view/solution.vue'
import park from '@/view/park.vue'
import policeWork from '@/view/policeWork.vue'
import cooperation from '@/view/cooperation.vue'
import contactUs from '@/view/contactUs.vue'
import AboutMustang from '@/view/AboutMustang.vue'
import guide from '@/view/guide.vue'


Vue.use(Router)
export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'top',
      redirect: '/yeMast',
      component: top,
      children: [
        {
          path: '/yeMast',
          name: 'yeMast',
          component: yeMast
        },
        {
          path: '/product',
          name: 'product',
          component: product
        },
        {
          path: '/solution',
          name: 'solution',
          component: solution
        },
        {
          path: '/security',
          name: 'security',
          component: security
        },
        {
          path: '/park',
          name: 'park',
          component: park
        },
        {
          path: '/policeWork',
          name: 'policeWork',
          component: policeWork
        },
        {
          path: '/cooperation',
          name: 'cooperation',
          component: cooperation
        },
        {
          path: '/contactUs',
          name: 'contactUs',
          component: contactUs
        },
        {
          path: '/AboutMustang',
          name: 'AboutMustang',
          component: AboutMustang
        }
      ]
    },
    {
      path: '/guide',
      name: 'guide',
      component: guide
      // meta: { title: '访客指引', keepAlive: true },
      // component: () => import('@/view/guide')
    },
    {
      path: '/xuzhou',
      name: 'xuzhou',
      meta: { title: '访客指引', keepAlive: true },
      component: () => import('@/view/xuzhou')
    },
    {
      path: '/nanjing',
      name: 'nanjing',
      meta: { title: '访客指引', keepAlive: true },
      component: () => import('@/view/nanjing')
    },
    {
      path: '/kejijia',
      name: 'kejijia',
      meta: { title: '访客指引', keepAlive: true },
      component: () => import('@/view/kejijia')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js